import React from "react";
import { useI18n } from "../i18n";

export const NavAlert = () => {
  const { t } = useI18n();

  return (
    <section className="nav-alert">
      <span>
        🚀 {t.alert.text}{" "}
        {/* Fichier statique : un <Link> react-router tenterait une navigation
            côté client et tomberait sur la page 404. */}
        <a href="/assets/cv.pdf" target="_blank" rel="noopener noreferrer">
          {t.alert.cv}
        </a>{" "}
        🚀
      </span>
    </section>
  );
};
